import {IOfferDetailStats} from "../../../offer/types/IOfferDetail";

export const getOfferStatsByGarages = (garages?: number, stats?: IOfferDetailStats["building_parameters_stats"]) => {
    if (!garages) {
        return null;
    }

    const key = "properties_with_garage" as const;
    const statsValue = stats?.[key];

    return statsValue && statsValue.total
        ? {
              key,
              ...statsValue
          }
        : null;
};
import {IOfferDetailStats} from "../../../offer/types/IOfferDetail";

export const getOfferStatsByGarages = (garages?: number, stats?: IOfferDetailStats["building_parameters_stats"]) => {
    if (!garages) {
        return null;
    }

    const key = "properties_with_garage" as const;
    const statsValue = stats?.[key];

    return statsValue && statsValue.total
        ? {
              key,
              ...statsValue
          }
        : null;
};
